// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"q5-z","colorTextValue":"r5-z","swatches":"s5-z","collapseLink":"t5-z","isCollapsed":"u5-z","dropdown":"v5-z","disabled":"w5-z"};